import { FunctionComponent, memo, useEffect, useState } from "react";

import CriteriumList from "./criteriumList";

import { IBrandSource } from "@lib/store/models/brandsModels";
import { ICriteriumNode } from "@lib/store/models/nodesModels";
import { useReferential } from "context/referentialContext";

export interface ICriteriumContainerProps {
  sectionName: string;
  sectionId: string;
  brandSourcesByCriteriumId?: { [id: string]: IBrandSource[] };
}

const CriteriumContainer: FunctionComponent<ICriteriumContainerProps> = ({
  sectionName,
  sectionId,
  brandSourcesByCriteriumId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [criteriums, setCriteriums] = useState<ICriteriumNode[]>([]);

  const { getCriteriums } = useReferential();

  useEffect(() => {
    setIsLoading(true);
    getCriteriums(sectionId)
      .then(setCriteriums)
      .finally(() => setIsLoading(false));
  }, [getCriteriums, sectionId]);

  return (
    <CriteriumList
      criteriums={criteriums}
      loading={isLoading}
      sectionName={sectionName}
      brandSourcesByCriteriumId={brandSourcesByCriteriumId}
    />
  );
};

export default memo(CriteriumContainer);
